import React, {cloneElement} from 'react'
import PropTypes from 'prop-types'
import {Tooltip, IconButton} from 'rambler-ui'
import styles from './styles.css'

export default function RowButton({
  label,
  children,
  position = 'right',
  className = '',
  ...props
}) {
  return (
    <Tooltip
      className={`${styles.root} ${className}`}
      position={position}
      content={label}
    >
      <IconButton {...props} type="flat" size={15} aria-label={label}>
        {cloneElement(children, {color: '#6674a6'})}
      </IconButton>
    </Tooltip>
  )
}

RowButton.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}
